import { CLEAR_TAGS } from '../actions/tags'

const tags = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_TAGS:
      state = {}
      break
  }
  return state
}

export default tags
